module.exports = __webpack_public_path__ + "static/media/oberflex-pinanoeudst101-1200x2490.ff385bac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-pinanoeudst101-1200x2490.jpg
// module id = 1050
// module chunks = 37